export const MODULE_ID = 'information';
export const BASIC_INFORMATION = [
    'firstName',
    'lastName',
    'email',
    'avatar',
    'dateOfBirth',
    'gender'
];
